import { APP_DISPLAY_NAME } from './brandingAssets';

/** Coordonnées publiques (alignées seed / parametres_plateforme). */
export const PLATFORM_CONTACT = {
  legalName: 'JCONSULT MY SARL',
  appName: APP_DISPLAY_NAME,
  addressLine1: 'Kinshasa',
  addressLine2: 'République Démocratique du Congo',
  /** Valeur par défaut si l’API branding est indisponible. */
  supportEmailDefault: 'academia@jconsultmy.com',
  /** Téléphone service clientèle — définir REACT_APP_PUBLIC_SUPPORT_PHONE au build si disponible. */
  supportPhone: (process.env.REACT_APP_PUBLIC_SUPPORT_PHONE || '').trim(),
  /** Créneaux officiels — 6 vacations de 2 h (calendrier SI-SEP). */
  vacationSlots: [
    '08h00 – 10h00',
    '10h00 – 12h00',
    '12h00 – 14h00',
    '14h00 – 16h00',
    '16h00 – 18h00',
    '18h00 – 20h00',
  ],
  vacationSlotsHint:
    'Chaque séance dure 2 h. Le jour (lun.·mer.·ven. ou mar.·jeu.·sam.) dépend du domaine choisi.',
} as const;
